import DailyStatsTableCard from 'components/DailyStatsTableCard';
import styled from 'styled-components';

export const DailyStatsTable = styled(DailyStatsTableCard)`
  &,
  &.MuiPaper-root {
    border: none;
  }
` as typeof DailyStatsTableCard;
